export enum AuthenticatorType {
    S = 'Text',
    P = 'Phone',
    E = 'Email',
    Q = 'QR Authenticator'
}

export enum AuthenticatorMemberType {
    S = 'Text',
    P = 'Phone',
    E = 'Email',
}


export enum TwilioType {
    S = 'Text',
    P = 'Phone',
}

export enum InternalType {
    E = 'Email',
}

export enum AuthenticatorMode {
    Onboarding,
    Selection,
    Configuration,
    Verification
}

export enum MFAUpdateStep {
    SelectMFA = 'SelectMFA',
    UpdateMFA = 'UpdateMFA',
    VerifyMFA = 'VerifyMFA'
}
